import { render, staticRenderFns } from "./OnboardingIntegrationGmail.vue?vue&type=template&id=130660cd&scoped=true&"
import script from "./OnboardingIntegrationGmail.vue?vue&type=script&lang=js&"
export * from "./OnboardingIntegrationGmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130660cd",
  null
  
)

export default component.exports